import type { MenuConfig } from '~typings/menu'

import permisosInventario, { RESOURCE_INVENTARIO } from '@/auth/permissions/modules/inventario'
import * as names from '@routes/inventario-consumo/nombres/transacciones'

const { transacciones } = permisosInventario

export default [
    {
        title: 'inventario.subopciones.ingreso_bodega',
        route: names.ROUTE_INGRESO_BODEGA,
        resource: RESOURCE_INVENTARIO,
        action: transacciones.ingresoBodega,
    },
    {
        title: 'inventario.subopciones.egreso_bodega',
        route: names.ROUTE_EGRESO_BODEGA,
        resource: RESOURCE_INVENTARIO,
        action: transacciones.egresoBodega,
    },
    {
        title: 'inventario.subopciones.confirmacion_transferencia',
        route: names.ROUTE_CONFIRMACION_TRANSFERENCIA,
        resource: RESOURCE_INVENTARIO,
        action: transacciones.confirmacionTransferencia,
    },
    {
        title: 'inventario.subopciones.consumo',
        resource: RESOURCE_INVENTARIO,
        // action: transacciones.consumo._perm,
        children: [
            {
                title: 'inventario.subopciones.gestion_solicitud_consumo',
                route: names.ROUTE_GESTION_SOLICITUD_CONSUMO,
                resource: RESOURCE_INVENTARIO,
                action: transacciones.gestionSolicitudConsumo,
            },
            {
                title: 'inventario.subopciones.aprobacion_solicitud_consumo',
                route: names.ROUTE_APROBACION_SOLICITUD_CONSUMO,
                resource: RESOURCE_INVENTARIO,
                action: transacciones.aprobacionSolicitudConsumo,
            },
            {
                title: 'inventario.subopciones.solicitud_consumo',
                route: names.ROUTE_SOLICITUD_CONSUMO,
                resource: RESOURCE_INVENTARIO,
                action: transacciones.solicitudConsumo,
            },
        ],
    },
    {
        title: 'inventario.subopciones.devolucion',
        resource: RESOURCE_INVENTARIO,
        // action: transacciones.devolucion._perm,
        children: [
            {
                title: 'inventario.subopciones.gestion_solicitud_devolucion',
                route: names.ROUTE_GESTION_SOLICITUD_DEVOLUCION,
                resource: RESOURCE_INVENTARIO,
                action: transacciones.gestionSolicitudDevolucion,
            },
            {
                title: 'inventario.subopciones.aprobacion_solicitud_devolucion',
                route: names.ROUTE_APROBACION_SOLICITUD_DEVOLUCION,
                resource: RESOURCE_INVENTARIO,
                action: transacciones.aprobacionSolicitudDevolucion,
            },
            {
                title: 'inventario.subopciones.solicitud_devolucion',
                route: names.ROUTE_SOLICITUD_DEVOLUCION,
                resource: RESOURCE_INVENTARIO,
                action: transacciones.solicitudDevolucion,
            },
        ],
    },
    {
        title: 'inventario.subopciones.transferencia',
        resource: RESOURCE_INVENTARIO,
        // action: transacciones.transferencia._perm,
        children: [
            {
                title: 'inventario.subopciones.gestion_solicitud_transferencia',
                route: names.ROUTE_GESTION_SOLICITUD_TRANSFERENCIA,
                resource: RESOURCE_INVENTARIO,
                action: transacciones.gestionSolicitudTransferencia,
            },
            {
                title: 'inventario.subopciones.aprobacion_solicitud_transferencia',
                route: names.ROUTE_APROBACION_SOLICITUD_TRANSFERENCIA,
                resource: RESOURCE_INVENTARIO,
                action: transacciones.aprobacionSolicitudTransferencia,
            },
            {
                title: 'inventario.subopciones.solicitud_transferencia',
                route: names.ROUTE_SOLICITUD_TRANSFERENCIA,
                resource: RESOURCE_INVENTARIO,
                action: transacciones.solicitudTransferencia,
            },
        ],
    },
    {
        title: 'inventario.subopciones.orden_pedido',
        resource: RESOURCE_INVENTARIO,
        // action: transacciones.ordenPedido._perm,
        children: [
            {
                title: 'inventario.subopciones.gestion_pedido',
                route: names.ROUTE_GESTION_ORDEN_PEDIDO,
                resource: RESOURCE_INVENTARIO,
                action: transacciones.gestionOrdenPedido,
            },
            {
                title: 'inventario.subopciones.nuevo_pedido',
                route: names.ROUTE_ORDEN_PEDIDO,
                resource: RESOURCE_INVENTARIO,
                action: transacciones.crearOrdenPedido,
            },
            {
                title: 'inventario.subopciones.aprobacion_pedido',
                route: names.ROUTE_APROBACION_ORDEN_PEDIDO,
                resource: RESOURCE_INVENTARIO,
                action: transacciones.aprobacionOrdenPedido,
            },
        ],
    },

    {
        title: 'inventario.subopciones.mis_solicitudes',
        route: names.ROUTE_GESTION_SOLICITUDES_ITEMS,
        resource: RESOURCE_INVENTARIO,
        action: transacciones.gestionSolicitudesItems,
    },
    {
        title: 'inventario.subopciones.soli_item',
        route: names.ROUTE_CREAR_SOLICITUD_ITEM,
        resource: RESOURCE_INVENTARIO,
        action: transacciones.crearSolicitudItem,
    },
    {
        title: 'inventario.subopciones.aprobacion_items',
        route: names.ROUTE_APROBACION_SOLICITUD_ITEM,
        resource: RESOURCE_INVENTARIO,
        action: transacciones.aprobacionSolicitudItem,
    },
    {
        title: 'inventario.subopciones.aprobacion_cont_items',
        route: names.ROUTE_APROBACION_CONTABLE_ITEMS,
        resource: RESOURCE_INVENTARIO,
        action: transacciones.aprobacionContableItems,
    },
    {
        title: 'inventario.subopciones.aprobacion_trib_items',
        route: names.ROUTE_APROBACION_TRIBUTARIA_ITEMS,
        resource: RESOURCE_INVENTARIO,
        action: transacciones.aprobacionTributariaItems,
    },
    {
        title: 'inventario.subopciones.solicitud_marca',
        route: names.ROUTE_CREAR_SOLICITUD_MARCA,
        resource: RESOURCE_INVENTARIO,
        action: transacciones.crearSolicitudMarca,
    },
    {
        title: 'inventario.subopciones.aprobacion_marca',
        route: names.ROUTE_APROBACION_MARCA,
        resource: RESOURCE_INVENTARIO,
        action: transacciones.aprobacionMarca,
    },
] as MenuConfig[]
